import React from 'react';

import type { PriceLevel } from '../../../../../core/data-sources/frapi/types.js';

type PriceProps = {
  price: PriceLevel;
};

const priceValue = {
  low: 1,
  medium: 2,
  high: 3,
};

const Price: React.FC<PriceProps> = ({ price }) => {
  const values = price !== 'none' && [0, 0, 0].fill(1, 0, priceValue[price]);

  return (
    <div className="prices">
      {values &&
        values.map((value, index) => (
          <span
            className={value ? 'price active' : 'price in-active'}
            key={`price-${index}`}
          >
            $
          </span>
        ))}
    </div>
  );
};

export default Price;
